<template>
    <div class="scrolling-modal">
        <article>
            <p>{{ translate('message') }}</p>
            <form ref="loginForm" novalidate @submit.stop.prevent>
                <label for="email" class="font-weight-bold">{{ translate('contact.email') }}</label>
                <span class="required ml-1">({{ translate('required') }})</span>
                <UIFormInput id="email" v-model="email" class="mb-3" type="email" required validation="email" @keyup.enter.native="login">
                    <template v-slot:error-message>
                        {{ translate('email.error') }}
                    </template>
                    <template v-slot:warning-message>
                        {{ translate('email.warning') }}
                    </template>
                </UIFormInput>
                <UIButton ref="login" variant="primary" type="submit" class="w-100" required @click.native="login">{{ translate('button.continueStep') }}</UIButton>
            </form>
        </article>
    </div>
</template>

<script>
import { UIFormInput, UIButton } from '@dundle/ui/components';
import { mapActions } from 'vuex';
import TranslationMixin from '~/mixins/TranslationMixin';

export default {
    components: {
        UIButton,
        UIFormInput,
    },
    mixins: [TranslationMixin],

    data() {
        return {
            email: null,
        };
    },

    methods: {
        ...mapActions({
            hideModal: 'ui/hideModal',
        }),

        async login() {
            if (this.$validation.validateForm(this.$refs.loginForm)) {
                if (this.$refs.login) this.$refs.login.startLoading();

                try {
                    await this.$user.login('guest', this.email);
                    this.hideModal();
                } finally {
                    if (this.$refs.login) this.$refs.login.stopLoading();
                }
            }
        },
    },
};
</script>

<i18n src="@dundle/locale/data/buttons.json"></i18n>
<i18n src="@dundle/locale/data/keywords.json"></i18n>
<i18n src="@dundle/locale/data/validation.json"></i18n>
<i18n></i18n>
